const normalizeRoutePath = (path) => {
  if (typeof path !== 'string') return '';
  return path.trim() || '';
};

export const isWelcomeRoute = (path) => {
  const normalizedPath = normalizeRoutePath(path);
  return normalizedPath === '/'
    || normalizedPath === '/sign-in'
    || normalizedPath === '/login';
};

export const isRecoveryCandidateRoute = (path) => {
  const normalizedPath = normalizeRoutePath(path);
  return normalizedPath === '/discover' || normalizedPath === '/';
};

export const shouldShowRecoveryBanner = (path) => !isWelcomeRoute(path)
  && isRecoveryCandidateRoute(path);

